import { FunctionComponent } from 'react';
import { FeedCard } from '../../components';
import { SearchFeedCommon } from '../../shared';

export const SearchFeed: FunctionComponent = () => {
  return <SearchFeedCommon CardComponent={FeedCard} />;
};
